const HEADERS = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"]

const GRID = [
	[null, null, null, null, null, null, 1],
	[2, 3, 4, 5, 6, 7, 8],
	[9, 10, 11, 12, 13, 14, 15],
	[16, 17, 18, 19, 20, 21, 22],
	[23, 24, 25, 26, 27, 28, 29],
	[30, 31, null, null, null, null, null],
]

const EVENTS: Record<number, { ticker: string; color: string }> = {
	7: { ticker: "AAPL", color: "bg-sky-500" },
	14: { ticker: "MSFT", color: "bg-sky-400" },
	19: { ticker: "JNJ", color: "bg-green-500" },
	24: { ticker: "T", color: "bg-sky-500" },
	28: { ticker: "VZ", color: "bg-amber-500" },
}

export function CalendarMockup() {
	return (
		<div className="rounded-2xl overflow-hidden border border-white/40 dark:border-sky-100/10 bg-white/80 dark:bg-sky-950/80 backdrop-blur-md shadow-2xl">
			{/* Browser chrome */}
			<div className="flex items-center gap-1.5 px-3 py-2.5 bg-sky-50/80 dark:bg-sky-900/40 border-b border-sky-100/60 dark:border-sky-800/30">
				<div className="w-2 h-2 rounded-full bg-red-400/70" />
				<div className="w-2 h-2 rounded-full bg-amber-400/70" />
				<div className="w-2 h-2 rounded-full bg-green-400/70" />
				<div className="ml-auto text-[9px] font-bold text-sky-700 dark:text-sky-300">BeeDiv</div>
			</div>

			{/* Month header */}
			<div className="px-3 pt-2.5 pb-1 flex items-center justify-between">
				<span className="text-xs font-bold text-sky-900 dark:text-sky-100">March 2025</span>
				<div className="flex gap-2">
					{[
						["Paid", "bg-sky-500"],
						["Ex-Date", "bg-amber-500"],
						["Earnings", "bg-indigo-500"],
					].map(([label, color]) => (
						<div key={label} className="flex items-center gap-0.5">
							<div className={`w-1.5 h-1.5 rounded-full ${color}`} />
							<span className="text-[7px] text-sky-600/60 dark:text-sky-400/50">{label}</span>
						</div>
					))}
				</div>
			</div>

			{/* Calendar grid */}
			<div className="px-2 pb-3">
				{/* Day headers */}
				<div className="grid grid-cols-7 mb-1">
					{HEADERS.map((h) => (
						<div
							key={h}
							className="text-center text-[8px] font-semibold text-sky-500/60 dark:text-sky-400/50 py-0.5"
						>
							{h}
						</div>
					))}
				</div>

				{/* Weeks */}
				{GRID.map((week, wi) => (
					<div key={wi} className="grid grid-cols-7 gap-px mb-0.5">
						{week.map((day, di) => {
							const event = day ? EVENTS[day] : null
							return (
								<div key={di} className="aspect-square flex flex-col items-center justify-center">
									{day && (
										<>
											<span
												className={`text-[8px] leading-none ${event ? "font-bold text-sky-900 dark:text-sky-100" : "text-sky-600/50 dark:text-sky-400/40"}`}
											>
												{day}
											</span>
											{event && (
												<div
													className={`${event.color} rounded text-white text-[6px] font-bold px-0.5 mt-0.5 leading-tight`}
												>
													{event.ticker}
												</div>
											)}
										</>
									)}
								</div>
							)
						})}
					</div>
				))}
			</div>
		</div>
	)
}
